export const getNumberOrNull = (input?: unknown) => {
  if (input === null) {
    return null;
  }
  return !Number.isNaN(Number(input)) ? Number(input) : null;
};
